// src/pages/income/business/IncomeBusinessDraftPreviewWindow.jsx
// ✅ 경영팀 미리보기 새 창 라우트 element — 얇은 래퍼(라우트 element는 부모가 props를
// 못 내려주므로 각 사업이 자기 config를 직접 넘겨야 한다).
import React from "react";
import IncomeDraftPreviewWindow from "../_shared/IncomeDraftPreviewWindow";
import incomeBusinessDraftConfig from "./incomeBusinessDraftConfig";

export default function IncomeBusinessDraftPreviewWindow() {
  return <IncomeDraftPreviewWindow config={incomeBusinessDraftConfig} />;
}
